import getStorageValue from '~/misc/getStorageValue';
import safeJSONParse from '~/misc/safeJSONParse';
import A from './types';
import {update} from './utils';

const initialState = {
  items: safeJSONParse(getStorageValue('recentSearches'), []),
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.RECENTSEARCHES_UPDATE: {
      const candidate = action.payload;

      if (!candidate.from_name && !candidate.to_name) {
        return null;
      }

      return {
        items: update(state.items, candidate),
      };
    }
  }

  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/recentSearches/reducer.js